import type { BatchEnrollmentCandidateVM } from "@shared-kernel/application/ports/admin/batch-enrollment-candidate";
import type { Dependencies } from "@redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const adminRetrieveBatchEnrollmentCandidateList = createAsyncThunk<
  BatchEnrollmentCandidateVM[],
  void,
  { extra: Partial<Dependencies> }
>("batchEnrollmentCandidates/adminRetrieveBatchEnrollmentCandidateList", async (_: void, { extra: { adminRepository } }) => {
  return adminRepository!.listBatchEnrollmentCandidates();
});
